import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ProTip from './ProTip';

import { styled, createTheme, ThemeProvider } from '@mui/material/styles';

import Copyright from './components/Copyright';

import IRPCalculatorPage from './pages/IRPCalculatorPage';

export default function App() {
  const theme = createTheme();

  return (

    <ThemeProvider theme={theme}>

      <IRPCalculatorPage />
      <Copyright />

    </ThemeProvider>
    // <Container maxWidth="sm">
    //   {/* <Box sx={{ my: 4 }}>
    //     <Typography variant="h4" component="h1" gutterBottom>
    //       Create React App example
    //     </Typography>
    //     <ProTip /> */}
    //     {/* <IRPCalculatorPage /> */}
        
    //   {/* </Box> */}
    // </Container>
  );
}